module.exports = __webpack_public_path__ + "hr.svg?6914581b147882aaf90bfb51a30c8caf";